<template>
  <div class="wrapper">
    <div class="img_wrapper">
      <img src="../../../assets/images/h5/bbs/pic01.png">
    </div>
    <!--   表单填写-->
    <pub-form></pub-form>
    <div class="image-box">
      <img src="../../../assets/images/h5/bbs/pic02.png">
    </div>
    <!--   表单填写-->
    <pub-form></pub-form>
    <div style="height: 50px"></div>
    <p class="company">山东依智教育科技有限公司 | <span class="statement" @click="statementOpen()">《个人信息保护声明》</span></p>
    <!--隐私政策弹框-->
    <div class="statement-cont-dig">
      <mt-popup v-model="popupVisible">
        <p style="text-align: right" @click="statementClose">X</p>
        <p style="text-align: center;font-weight: bold;font-size: 19px;margin-bottom: 20px">《个人信息保护声明》</p>
        <div class="statement-cont">
          <p style="margin-bottom: 20px">该声明由本页面创建者（即下文的"我们/公司"）向您提供，包涵涉及您个人信息权益的重要约定，请您在提供个人信息前仔细阅读。如有问题，可联系本页面创建者。</p>
          <p style="margin-bottom: 20px">公司名称：山东依智教育科技有限公司</p>
          <p>我们/公司非常重视用户信息的保护。您在使用我们相关服务（以下简称"服务"），并在相应页面填写个人信息前，请您务必仔细阅读本声明。<span style="font-weight: bold">您一旦主动在页面提供您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、使用您的相关信息。</span>
          </p>
          <p style="font-weight: bold">一、个人信息的收集</p>
          <p>我们提供服务时，可能会收集下列与您有关的个人信息：</p>
          <p>您在使用本页面所涉及的表单、智能电话、卡券领取、客服工具等功能中提供的信息，包括姓名、手机号及使用本页面提供的产品/服务涉及的必要信息。
            <span style="font-weight: bold">请您注意，具体需要提供的信息可能会根据我们提供的产品/服务的不同而有所差异，请以向您展示的产品/服务以及所对应的要求提供相关个人信息，我
        们会在产品/服务页面或下文向您说明相关个人信息的收集和使用规则。</span></p>
          <p> 2、您需要注意的是，以上个人信息均是您自愿提供。 <span style="font-weight: bold">您有权拒绝提供，但可能无法正常使用相应的服务、功能或者无法达到服务拟达到的效果。</span>
          </p>
          <p style="font-weight: bold"> 二、个人信息的使用</p>
          <p>1、您同意，我们可以通过以下方式对个人信息进行使用:</p>
          <p style="font-weight: bold"> (1)我们收集您的姓名、手机号用于及时与您取得联系。并与您沟诵产品或服务的相关事宜。</p>
          <p style="font-weight: bold">(2)为了更好的提供服务，您在通过电话或客服工具与我们沟通时，我们会记录您的手机号及相关沟通情况。</p>
          <p style="font-weight: bold"> (3)如您拟查询、修改、删除、撤回授权您提交的个人信息的，或对个人信息保护问题有任何疑问或投诉，您可以与我们联系，我们将尽快配合处理。</p>
          <p> 2、我们将严格保护您的个人信息安全。我们将采用适当制度、组织和安全技术等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。</p>
          <p> 3、为了实现.上述目的，我们可能会委托我们的技术合作伙伴( 例如呼叫服务商)为您提供服务，并由其在服务范围内进行合法、正当、必要地使用。</p>
          <p>三、未成年人信息的特殊保护</p>
          <p>1、若您是未满18周岁的未成年人，在使用本功能前，应在您的父母或其他监托我们的技术合作伙伴( 例如呼叫服务商)为您提供服务，并由其在服务范围内进行合法、正当、必要地使用。</p>
          <p>2、若您是未满14周岁的未成年人的监护人，在使用本功能前，应为您的被监护人阅读并同意本隐私政策。</p>
          <p style="font-weight: bold"> 四、适用法律</p>
          <p>本声明适用中华人民共和国法律。</p>
          <p style="font-weight: bold"> 五、变更</p>
          <p>我们会适时对本声明进行修订，该等修订构成本声明的一部分。公司会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。</p>
        </div>
        <div class="statement-btn" @click="statementClose">
          <span>我已阅读</span>
        </div>
      </mt-popup>
    </div>
  </div>

</template>
<script>
import PubForm from './pubForm'
import {getConversion} from "../../../apis/apis";
import {Toast} from "_mint-ui@2.2.13@mint-ui";

export default {
  components: {
    PubForm
  },
  name: "",
  data() {
    return {
      popupVisible: false, //隐私政策弹窗
      clickid: "",
    }
  },
  methods: {
    //隐私保护声明打开
    statementOpen() {
      this.popupVisible = true;
    },
    //隐私保护政策关闭
    statementClose() {
      this.popupVisible = false;
    },
    //获取地址栏参数
    GetQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // https://analytics.oceanengine.com/api/v2/conversion  上传广告回调到抖音
    async getConversion() {
      try {
        let params = {
          "event_type": "form",
          "context": {
            "ad": {
              "callback": this.clickid,//callback 这里需要填写的就是从启动参数里获取的 clickid
            }
          },
          "timestamp": new Date().valueOf(),
        }
        // alert(params)
        let {
          data
        } = await getConversion(params);
        console.log("data.code", data.code);
        if (data.code == 0) {
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.GetQueryString();
    let myurl = this.GetQueryString("clickid");
    if (myurl != null && myurl.toString().length > 1) {
      this.clickid = (this.GetQueryString("clickid"));
    }
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
}

.img_wrapper {
  width: 100%;
  height: 100%;
}

.img_wrapper img {
  width: 100%;
}

.image-box {
  position: relative;
  overflow: hidden;
}

.image-box img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  border: 0;
  -webkit-user-drag: none;
}

/*个人信息弹框*/
.statement-cont-dig .mint-popup {
  width: 80%;
  padding: 40px 20px;
}

.statement-cont-dig .mint-popup p {
  font-size: 28px;
  line-height: 40px;
}

.statement-cont {
  height: 600px;
  overflow: auto;
  border-bottom: 1px solid #ececec;
}

.statement-cont-dig .statement-btn {
  text-align: center;
  margin-top: 30px;
  font-size: 38px;
}

/*版权*/
.company {
  width: 100%;
  text-align: center;
  padding: 25px;
  background: #ececec;
  position: fixed;
  bottom: 0;
  color: #666666;
}

.statement {
  color: #26a2ff;
}


</style>



// WEBPACK FOOTER //
// src/pages/h5/bbsH5/bbsPromotePage.vue